import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const rejectAssignmentRequest = async (requestId, review_comment = '') => {
  try {
    const response = await apiClient.post(
      `/systemInvoiceRoleManagement/requests/${requestId}/reject`,

      {
        review_comment,
      }
    );
    const message = response?.data?.message || 'Assignment change rejected';
    notify('success', message);
    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.response?.data?.error || 'Failed to reject request';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
